import * as React from "react";
import {
  Text,
  View,
  Image,
  TouchableOpacity,
  TouchableHighlight,
} from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import Ionicons from "@expo/vector-icons/Ionicons";
import API_KEY from "../API_KEY";
import Chart from "./Chart";
import { Card, Header, Button } from "react-native-elements";
import StockCard from "./StockCard";
import StockTickers from "../stockTickers.json";
import { ScrollView } from "react-native-gesture-handler";
import SubmitButton from "../components/UI/SubmitButton";
import Icon from "react-native-vector-icons/FontAwesome";

const alpha = require("alphavantage")({ key: API_KEY });

export default class HomeScreen extends React.PureComponent {
  state = {
    selectedStock: "",
  };
  onSelectStock = (stockType) => {
    this.setState({ selectedStock: stockType });
    this.props.switchOtherStockCard(stockType);
  };
  render() {
    return (
      <View>
        {this.props.date ? (
          <Text
            style={{
              fontSize: 20,
              color: "white",
              justifyContent: "center",
              alignContent: "center",
              textAlign: "center", // <-- the magic

              padding: 20,
            }}
          >
            Which company will do better on: {"\n"}
            {this.props.date}
          </Text>
        ) : null}

        {this.props.stock1.name !== "" ? (
          <TouchableHighlight
            onPress={() => {
              this.onSelectStock("stock1");
            }}
          >
            <StockCard
              stock={this.props.stock1}
              selected={this.state.selectedStock === "stock1"}
            />
          </TouchableHighlight>
        ) : null}

        {this.props.readyToSubmit ? (
          <View
          // style={{
          //   position: "relative",
          //   left: "35%",
          //   bottom: "5%",
          //   marginBottom: -20,
          // }}
          >
            <Button
              type="outline"
              title="Submit"
              onPress={() => {
                this.props.submitBracket();
              }}
            />
          </View>
        ) : // <Button
        //   title={"Submit "}
        //   icon={<Icon name="arrow-right" size={15} color="white" />}
        //   buttonStyle={{
        //     position: "relative",
        //     top: -10,
        //   }}
        //   type="clear"
        //   onPress={() => {
        //     this.props.submitBracket();
        //   }}
        // />
        null}
        {this.props.stock2.name !== "" ? (
          <TouchableHighlight
            onPress={() => {
              this.onSelectStock("stock2");
            }}
          >
            <StockCard
              stock={this.props.stock2}
              selected={this.state.selectedStock === "stock2"}
            />
          </TouchableHighlight>
        ) : null}
      </View>
    );
  }
}
